import React from "react";
import { Hero } from "../sections/Hero";
import { WhyVoltpdr } from "../sections/WhyVoltpdr";
import { Services } from "../sections/Services";
import { Stats } from "../sections/Stats";
import { Process } from "../sections/Process";
import { Testimonials } from "../sections/Testimonials";
import { Partners } from "../sections/Partners";

export default function Home() {
  return (
    <>
      <Hero />
      <WhyVoltpdr />
      <Services />
      <Stats />
      <Process />
      <Testimonials />
      <Partners />
    </>
  );
}
